import { Link } from "react-router-dom";
import { HeaderLogo } from "./Brand";

export const SiteHeader = ({ right }) => (
  <header className="sticky top-0 z-30 border-b border-line bg-white/90 backdrop-blur-md" data-testid="site-header">
    <div className="mx-auto flex h-16 max-w-6xl items-center justify-between gap-2 px-3 sm:px-6">
      <div className="min-w-0 shrink"><HeaderLogo /></div>
      <div className="flex shrink-0 items-center gap-2 sm:gap-3">{right}</div>
    </div>
  </header>
);

export const SiteFooter = () => (
  <footer className="mt-16 border-t border-line bg-brand-pale" data-testid="site-footer">
    <div className="mx-auto flex max-w-6xl flex-col gap-3 px-4 py-8 text-sm text-ink sm:flex-row sm:items-center sm:justify-between sm:px-6">
      <span>© {new Date().getFullYear()} LineGone · Prices in Canadian dollars (CAD)</span>
      <nav className="flex gap-5">
        <Link to="/terms" className="link-lg" data-testid="footer-terms-link">Terms of Service</Link>
        <Link to="/privacy" className="link-lg" data-testid="footer-privacy-link">Privacy Policy</Link>
        <Link to="/dashboard" className="link-lg" data-testid="footer-venues-link">For venues</Link>
      </nav>
    </div>
  </footer>
);

export const PoweredBy = () => (
  <div className="py-6 text-center text-xs text-muted2" data-testid="powered-by">
    Powered by <span className="font-heading font-extrabold"><span className="text-ink">Line</span><span className="text-brand">Gone</span></span>
    {" · "}<Link to="/terms" className="link-lg">Terms</Link>{" · "}<Link to="/privacy" className="link-lg">Privacy</Link>
  </div>
);

export const PracticeBanner = ({ text = "PRACTICE — no real payment. Use a Stripe test card (4242 4242 4242 4242).", testid = "practice-banner" }) => (
  <div className="border-y-2 border-dashed border-ink bg-white px-4 py-2 text-center text-sm font-black tracking-wide text-ink" data-testid={testid}>
    {text}
  </div>
);

export const Spinner = ({ label = "Loading…" }) => (
  <div className="flex min-h-[40vh] items-center justify-center text-muted2" data-testid="loading">
    <span className="mr-3 h-5 w-5 animate-spin rounded-full border-2 border-brand border-t-transparent" />{label}
  </div>
);
